import { __decorate } from "tslib";
import { attr } from '@microsoft/fast-element';
import { LoadingButton } from '../common/LoadingButton';
import { ensureDefaultAttribute } from '../common/utils/Attributes';
export class ButtonComponent extends LoadingButton {
    constructor() {
        super(...arguments);
        this.fullwidth = false;
        this.disabled = false;
    }
    connectedCallback() {
        super.connectedCallback();
        ensureDefaultAttribute(this, 'type', 'button');
        ensureDefaultAttribute(this, 'variant', 'primary');
    }
}
__decorate([
    attr
], ButtonComponent.prototype, "size", void 0);
__decorate([
    attr
], ButtonComponent.prototype, "variant", void 0);
__decorate([
    attr({ mode: 'boolean' })
], ButtonComponent.prototype, "fullwidth", void 0);
__decorate([
    attr({ mode: 'boolean' })
], ButtonComponent.prototype, "disabled", void 0);
